import React from "react";
import Input from "Components/UI/Input";
import { useFormContext } from "react-hook-form";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import dayjs from "dayjs";
const isStatusOption = [
  { id: 1, label: "Yes", value: true },
  { id: 0, label: "No", value: false },
];
const RepaymentModal = ({ onSubmit, show = false, handleClose }) => {
  const {
    handleSubmit,
    formState: { errors },
    watch,
    trigger,
    setValue,
    getValues,
  } = useFormContext();

  // capture the initial balance once so subsequent edits don't cumulatively change it
  // capture the initial balance once so subsequent edits don't cumulatively change it
  const initialBalanceRef = React.useRef(null);
  React.useEffect(() => {
    // initialize initial balance when modal is shown (or on mount)
    const b = getValues("advancePaymentDetails.balanceAmount");
    const install = getValues("advancePaymentDetails.installmentAmount");
    const source = b === undefined || b === null || b === "" ? install : b;
    const parsed =
      source === undefined || source === null || source === ""
        ? 0
        : parseFloat(String(source).replace(/,/g, ""));
    initialBalanceRef.current = isNaN(parsed) ? 0 : parsed;
  }, [show]);

  return (
    <Modal show={show} onHide={handleClose} animation={true} centered>
      <Modal.Header
        className="modal-header border-0 custom-modal-header"
        style={{ justifyContent: "space-between" }}
      >
        <div className="page-title">
          <h4>Update Repayment</h4>
        </div>
        <button type="button" className="close" onClick={handleClose}>
          <span aria-hidden="true">×</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)} className="needs-validation">
          <div className="form-row">
            <div className="mb-3">
              <Input
                name="advancePaymentDetails.installmentDate"
                type="date"
                placeholder="Installment Date"
                className={`form-control ${
                  errors?.advancePaymentDetails?.installmentDate
                    ? "is-invalid"
                    : ""
                }`}
                label="Installment Date"
                labelClassName="form-label"
                required={true}
                requiredMessage="Installment date is required"
                defaultValue=""
                dateFormat="YYYY-MM-DD"
                getPopupContainer={(trigger) => trigger.parentNode}
                // disabledDate={(current) => {
                //   return current < dayjs().subtract(1, "day").endOf("day");
                // }}
              />
            </div>

            <div className="mb-3">
              <Input
                name="advancePaymentDetails.installmentAmount"
                label="Installment Amount"
                placeholder="Installment Amount"
                className={`form-control ${
                  errors?.advancePaymentDetails?.installmentAmount
                    ? "is-invalid"
                    : ""
                }`}
                labelClassName="form-label"
                type="text"
                required={true}
                requiredMessage="Installment Amount is requried"
              />
            </div>

            <div className="mb-3">
              <Input
                name="advancePaymentDetails.paidAmount"
                label="Paid Amount"
                placeholder="Paid Amount"
                className={`form-control ${
                  errors?.advancePaymentDetails?.paidAmount ? "is-invalid" : ""
                }`}
                labelClassName="form-label"
                type="text"
                required={true}
                requiredMessage="Paid Amount is requried"
                onInput={(e) => {
                  const raw = e.target.value;
                  // keep user's input format but strip any non-numeric except dot and minus for parsing
                  const sanitized =
                    raw === "" ? "" : String(raw).replace(/[^0-9.-]/g, "");
                  const paid = sanitized === "" ? NaN : parseFloat(sanitized);

                  // determine initial balance (captured or fallback to current form values)
                  const initialBalance =
                    initialBalanceRef.current ??
                    (() => {
                      const b = getValues(
                        "advancePaymentDetails.balanceAmount"
                      );
                      const install = getValues(
                        "advancePaymentDetails.installmentAmount"
                      );
                      const source =
                        b === undefined || b === null || b === "" ? install : b;
                      const parsed =
                        source === undefined || source === null || source === ""
                          ? 0
                          : parseFloat(String(source).replace(/,/g, ""));
                      return isNaN(parsed) ? 0 : parsed;
                    })();

                  if (!isNaN(paid)) {
                    setValue("advancePaymentDetails.paidAmount", sanitized);
                    const balanceAmount = initialBalance - paid;
                    setValue(
                      "advancePaymentDetails.remainingBalance",
                      isNaN(balanceAmount) ? 0 : balanceAmount
                    );
                  }
                }}
              />
            </div>
            <div className="mb-3">
              <Input
                name="advancePaymentDetails.balanceAmount"
                label="Balance Amount"
                placeholder="Balance Amount"
                className={`form-control ${
                  errors?.advancePaymentDetails?.balanceAmount
                    ? "is-invalid"
                    : ""
                }`}
                labelClassName="form-label"
                type="text"
                required={true}
                requiredMessage="Balance Amount is requried"
                readonly={true}
              />
            </div>

            <div className="mb-3">
              <Input
                name="advancePaymentDetails.remainingBalance"
                label="Remaining Balance Amount"
                placeholder="Remaining Balance Amount"
                className={`form-control ${
                  errors?.advancePaymentDetails?.remainingBalance
                    ? "is-invalid"
                    : ""
                }`}
                labelClassName="form-label"
                type="text"
                required={true}
                requiredMessage=""
                readonly={true}
                value={watch("advancePaymentDetails.remainingBalance")}
              />
            </div>

            <div className="mb-3">
              <Input
                name="advancePaymentDetails.showInPayslip"
                type="commonSelect"
                placeholder="Select Show in Payslip"
                className={`form-control select ${
                  errors?.advancePaymentDetails?.showInPayslip
                    ? "is-invalid"
                    : ""
                }`}
                label="Show in Payslip ?"
                labelClassName="form-label"
                optionData={isStatusOption}
                required={true}
                requiredMessage="Show in Payslip is required"
                onChange={(selectedOption) => {
                  setValue(
                    "advancePaymentDetails.showInPayslip",
                    selectedOption
                  );
                  trigger("advancePaymentDetails.showInPayslip");
                }}
                defaultValue={watch("advancePaymentDetails.showInPayslip")}
                getPopupContainer={(trigger) => trigger.parentNode}
              />
            </div>
          </div>
          <div className="text-end mt-3">
            <button type="submit" className="btn btn-primary">
              Save
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

RepaymentModal.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default RepaymentModal;
